import Script from 'next/script';
import { useEffect, useState } from 'react';

function isEmployersPath() {
  return (
    typeof window !== 'undefined' &&
    window.location.pathname.startsWith('/employers')
  );
}

export default function EmployersLinkedInTag() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    // run on mount + on SPA navigations (Next Pages Router triggers mount on route change)
    setShouldLoad(isEmployersPath());
  }, []);

  if (!shouldLoad) return null;

  return (
    <Script id="linkedin-insight" strategy="afterInteractive">
      {`
        _linkedin_partner_id = "7851756";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
        (function(){
          var s = document.getElementsByTagName("script")[0];
          var b = document.createElement("script");
          b.type = "text/javascript"; b.async = true;
          b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
          s.parentNode.insertBefore(b, s);
        })();
      `}
    </Script>
  );
}
